/**
 * Hash Utility - Client-side password hashing
 *
 * Deterministic hash function matching backend AppUtils.genHash()
 * NOTE: This is NOT cryptographically secure - only for obfuscation during transmission
 */

export function genHash(password) {
  password = String(password);
  return Math.abs(
    password.split("").reduce(
      (a, b) => (((a << 5) - a) + b.charCodeAt(0)) | 0,
      0
    )
  );
}

export function isValidEmail(email) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}
